<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-2" v-if="bill">
      <v-layout>
        <v-flex md class="pa-0">
          <v-data-table
            style="border: solid 1px lightgray;"
            class="mr-2"
            :headers="headers"
            :items="products"
            :single-select="singleSelect"
            item-key="name"
            hide-default-footer
            hide-default-header
          >
            <template v-slot:top>
              <autocomplete-product
                class="ma-2"
                v-model="newProduct"
                item-text="name"
                label="Tìm Sản Phẩm"
                @change="addNewProduct"
              ></autocomplete-product>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small @click="deleteProduct(item)">delete</v-icon>
            </template>
            <template v-slot:item.price="{ item }">
              <div
                class="text-right body-2 font-weight-black"
              >{{item.price * item.quantity | formatMoney}}</div>
            </template>
            <template v-slot:item.quantity="props">
              <v-edit-dialog :return-value.sync="props.item.quantity" large persistent>
                <div>{{ props.item.quantity }}</div>
                <template v-slot:input>
                  <div class="mt-4 title">Update Iron</div>
                </template>
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.quantity"
                    label="Edit"
                    single-line
                    type="number"
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex md4>
          <bill :bill="bill" :products="products" @save="saveBill"></bill>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Bill from '@/modules/sales/BillEditForm.vue'
import utils from '@/plugins/utils.js'
import AutocompleteProduct from '@/components/basic/input/AutocompleteProduct.vue'
import _ from 'lodash'
export default {
  components: { Bill, AutocompleteProduct },
  props: {
    bill: Object,
    state: Boolean
  },
  created () {
    this.refresh()
  },
  data () {
    return {
      singleSelect: false,
      newProduct: null,
      dialog: false,
      headers: [
        {
          text: 'Mã Sản Phẩm',
          align: 'start',
          sortable: false,
          value: 'code'
        },
        { text: 'Sản Phẩm', value: 'title' },
        { text: 'Số Lượng', value: 'quantity' },
        { text: 'Giá', value: 'price' },
        { text: 'Thành Tiền', value: 'total' },
        { text: 'Hành Động', value: 'actions' }
      ],
      products: []
    }
  },
  computed: {
    ...mapGetters('app', ['department']),
    ...mapGetters('auth', ['profile'])
  },
  methods: {
    ...mapActions('billDetail', ['updateBill']),
    addNewProduct (product) {
      this.products.push(product)
      this.newProduct = null
    },
    deleteProduct (product) {
      this.products = this.products.filter(p => p.id !== product.id)
    },
    refresh () {
      this.products = _.get(this.bill, 'items', []).map(p => ({
        ...p,
        quantity: p.quantity || 1
      }))
    },
    saveBill (bill) {
      this.$emit('updateBill', {
        ...bill,
        data: { ...bill.data, updated: this.profile }
      })
    }
  },
  filters: {
    formatMoney (data) {
      return utils.formatMoney(data)
    }
  },
  watch: {
    state (state) {
      this.dialog = state
    },
    bill () {
      this.refresh()
    }
  }
}
</script>
